module.exports = __webpack_public_path__ + "img/组 489@2x.e370eea0.png";